module.exports = __webpack_public_path__ + "img/mantenimiento.e213397d.png";